import React from 'react';
import { Platform } from 'react-native';
import { AppDisplayImage, RenderImagesData } from './types';
import NativeImageView from './NativeImageView';
import WebImageView from './WebImageView';

export type FullScreenImageViewOwnProps<TImage> = {
    renderImagesData: RenderImagesData<TImage>;
    renderImages: (
        images: AppDisplayImage<TImage>[],
        onPress: (image: AppDisplayImage<TImage>) => void,
        getIsPressEnabled: (image: AppDisplayImage<TImage>) => boolean,
    ) => React.ReactNode;
};

export type FullScreenImageViewProps<TImage> = FullScreenImageViewOwnProps<TImage>;

const FullScreenImageView = <TImage,>(props: FullScreenImageViewProps<TImage>): React.ReactNode => {
    return (
        <>
            {props.renderImages(
                props.renderImagesData.appDisplayImages,
                props.renderImagesData.onPress,
                props.renderImagesData.getIsPressEnabled,
            )}
            {Platform.OS === 'web' ? (
                <WebImageView
                    images={props.renderImagesData.viewerImages}
                    imageIndex={props.renderImagesData.imageIndex}
                    isOpen={!!props.renderImagesData.isOpen}
                    onClose={props.renderImagesData.onClose}
                />
            ) : (
                <NativeImageView
                    images={props.renderImagesData.viewerImages}
                    imageIndex={props.renderImagesData.imageIndex}
                    isOpen={!!props.renderImagesData.isOpen}
                    onClose={props.renderImagesData.onClose}
                />
            )}
        </>
    );
};

export default FullScreenImageView;
